module.exports = __webpack_public_path__ + "static/media/sk-SK.8832266a.md";